import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button, Table, Spinner } from "react-bootstrap";
import axios from "axios";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";
import { toast } from "react-toastify";

const JVScreen = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  const [companyCodes, setCompanyCodes] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [postingKeys, setPostingKeys] = useState([]);
  const [glCodes, setGlCodes] = useState([]);
  const [transactionCodes, setTransactionCodes] = useState([]);
  const [resourceList, setResourceList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [currencyList, setCurrencyList] = useState([]);


  const orgId = user?.organisationId.toString();

  const [header, setHeader] = useState({
    companyCode: "",
    fy: "",
    postingDate: "",
    documentDate: "",
    documentType: "",
    referenceNumber: "",
  });

  const [items, setItems] = useState([
  {
    postingKey: "",
    glCode: "",
    transactionCode: "",
    itemRef: "",
    amount: "",
    resourceId: "",
    projectId: "",
    currencyCode: "", // ⬅ NEW FIELD
  },
]);


  useEffect(() => {
    if (!orgId) return;

    const fetchDropdownData = async () => {
      setLoading(true);
      try {
        const [
          companyRes,
          docRes,
          postingRes,
          glRes,
          trnRes,
          resourceRes,
          projectRes,
          currencyRes,
        ] = await Promise.all([
          axios.get(`${Base_URL}/CompanyCode/GetByOrganisationId/${orgId}`),
          axios.get(`${Base_URL}/JVScreen/GetDocumnetTypes`),
          axios.get(`${Base_URL}/JVScreen/GetPostingKeys`),
          axios.get(`${Base_URL}/JVScreen/GetGeneralLedger`),
          axios.get(`${Base_URL}/JVScreen/GetTransactionCode`),
          axios.get(`${Base_URL}/SalaryProcess/ResourceMastersByOrgId/${orgId}`),
          // axios.get(`${Base_URL}/ProjectMaster/GetProjectsByOrg/${orgId}`),
          axios.get(`${Base_URL}/CurrencyMaster/GetAllCurrencies`),
        ]);

        setCompanyCodes(companyRes.data.data || []);
        setDocumentTypes(docRes.data || []);
        setPostingKeys(postingRes.data || []);
        setGlCodes(glRes.data || []);
        setTransactionCodes(trnRes.data || []);
        setResourceList(resourceRes.data || []);
        setProjectList(projectRes.data || []);
        setCurrencyList(currencyRes.data || []);

      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    };

    fetchDropdownData();
  }, [orgId]);

  const handleItemChange = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    setItems(updated);
  };

  const addRow = () => {
    setItems([
      ...items,
      {
        postingKey: "",
        glCode: "",
        transactionCode: "",
        itemRef: "",
        amount: "",
        resourceId: "",
        projectId: "",
        currencyCode: "",

      },
    ]);
  };

  const removeRow = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    const payload = {
      orgId,
      ...header,
      items,
    };
    const res=await axios.post(`${Base_URL}/JVScreen/PostJv`,payload);

    if(res.status===200){
      toast.success("Journal Voucher submitted successfully");
    }
    else{
      toast.error("Failed to submit Journal Voucher");
    }
  };

  return (
    <div className="container mt-4">
      <h4 className="mb-3 fw-bold">Journal Voucher Entry</h4>

      {loading && (
        <div className="text-center">
          <Spinner animation="border" />
        </div>
      )}

      {/* ---------- Accounting Header ---------- */}
      <Form onSubmit={handleSubmit}>
        <h5 className="fw-semibold text-primary mb-3">Accounting Header</h5>

        <Row className="mb-3">
          <Col md={4}>
            <Form.Group>
              <Form.Label>Organisation ID</Form.Label>
              <Form.Control value={orgId} disabled />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label>Company Code</Form.Label>
              <Form.Select
                value={header.companyCode}
                onChange={(e) => setHeader({ ...header, companyCode: e.target.value })}
              >
                <option value="">Select</option>
                {companyCodes.map((c) => (
                  <option key={c.companyCode} value={c.companyCode}>
                    {c.companyCode} - {c.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label>FY Variant</Form.Label>
              <Form.Select
                value={header.fy}
                onChange={(e) => setHeader({ ...header, fy: e.target.value })}
              >
                <option value="">Select</option>
                {[2024, 2025, 2026, 2027].map((yr) => (
                  <option key={yr}>{yr}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={4}>
            <Form.Group>
              <Form.Label>Posting Date</Form.Label>
              <Form.Control
                type="date"
                value={header.postingDate}
                onChange={(e) =>
                  setHeader({ ...header, postingDate: e.target.value })
                }
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label>Document Date</Form.Label>
              <Form.Control
                type="date"
                value={header.documentDate}
                onChange={(e) =>
                  setHeader({ ...header, documentDate: e.target.value })
                }
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label>Document Type</Form.Label>
              <Form.Select
                value={header.documentType}
                onChange={(e) =>
                  setHeader({ ...header, documentType: e.target.value })
                }
              >
                <option value="">Select</option>
                {documentTypes.map((d) => (
                  <option key={d.code} value={d.code}>
                    {d.code} - {d.description}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col md={4}>
            <Form.Group>
              <Form.Label>Reference Number</Form.Label>
              <Form.Control
                type="text"
                value={header.referenceNumber}
                onChange={(e) =>
                  setHeader({ ...header, referenceNumber: e.target.value })
                }
              />
            </Form.Group>
          </Col>
        </Row>

        {/* ---------- Accounting Items ---------- */}
        <h5 className="fw-semibold text-primary mb-3">Accounting Items</h5>

        <Table bordered hover size="sm" className="table align-middle">
          <thead className="table-dark">
            <tr>
              <th>Posting Key</th>
              <th>GL Code</th>
              <th>Transaction Code</th>
              <th>Item Ref</th>
              <th>Amount</th>
              <th>Resource Id</th>
              <th>Project Id</th>
              <th>Currency</th>

              <th style={{ width: "60px" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {items.map((row, i) => (
              <tr key={i}>
                <td>
                  <Form.Select
                    value={row.postingKey}
                    onChange={(e) => handleItemChange(i, "postingKey", e.target.value)}
                  >
                    <option value="">Select</option>
                    {postingKeys.map((p) => (
                      <option key={p.code} value={p.code}>
                        {p.code} - {p.description}
                      </option>
                    ))}
                  </Form.Select>
                </td>

                <td>
                  <Form.Select
                    value={row.glCode}
                    onChange={(e) => handleItemChange(i, "glCode", e.target.value)}
                  >
                    <option value="">Select</option>
                    {glCodes.map((g) => (
                      <option key={g.glmasterId} value={g.glmasterId}>
                        {g.glmasterId} - {g.description}
                      </option>
                    ))}
                  </Form.Select>
                </td>

                <td>
                  <Form.Select
                    value={row.transactionCode}
                    onChange={(e) =>
                      handleItemChange(i, "transactionCode", e.target.value)
                    }
                  >
                    <option value="">Select</option>
                    {transactionCodes.map((t) => (
                      <option key={t.zactrCode} value={t.zactrCode}>
                        {t.zactrCode} - {t.zactrDescription}
                      </option>
                    ))}
                  </Form.Select>
                </td>

                <td>
                  <Form.Control
                    type="text"
                    value={row.itemRef}
                    onChange={(e) => handleItemChange(i, "itemRef", e.target.value)}
                  />
                </td>

                <td>
                  <Form.Control
                    type="number"
                    step="0.01"
                    value={row.amount}
                    onChange={(e) => handleItemChange(i, "amount", e.target.value)}
                  />
                </td>

                <td>
                  <Form.Select
                    value={row.resourceId}
                    onChange={(e) => handleItemChange(i, "resourceId", e.target.value)}
                  >
                    <option value="">Select</option>
                    {resourceList.map((r, idx) => (
                      <option key={idx} value={r.resourceId}>
                        {r.resourceId} - {r.name}
                      </option>
                    ))}
                  </Form.Select>
                </td>

                <td>
                  <Form.Select
                    value={row.projectId}
                    onChange={(e) => handleItemChange(i, "projectId", e.target.value)}
                  >
                    <option value="">Select</option>
                    {projectList.map((p, idx) => (
                      <option key={idx} value={p.projectId}>
                        {p.prozmaPrId} - {p.prTitle}
                      </option>
                    ))}
                  </Form.Select>
                </td>
                <td>
  <Form.Select
    value={row.currencyCode}
    onChange={(e) => handleItemChange(i, "currencyCode", e.target.value)}
  >
    <option value="">Select</option>
    {currencyList.map((c, idx) => (
      <option key={idx} value={c.currencyCode}>
        {c.currencyCode} - {c.currencyName}
      </option>
    ))}
  </Form.Select>
</td>


                <td className="text-center">
                  {items.length > 1 && (
                    <Button size="sm" variant="danger" onClick={() => removeRow(i)}>
                      ❌
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <Button variant="secondary" size="sm" onClick={addRow}>
          ➕ Add Item
        </Button>

        <div className="text-end mt-3">
          <Button type="submit" variant="primary">
            Submit JV
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default JVScreen;
